import Vue from 'vue'
import log from '@/utils/log'

export default {
	setState(state, args) {
		log.info('Mutation debug setState', args)
		Vue.set(state, 'state', args)
	},
}
